document.addEventListener('DOMContentLoaded',function(){
  var primary=document.querySelector('[data-symbol]');
  var primaryPosition=document.querySelector('select[name="properties[Logoposition]"]');
  var ribbon=document.querySelector('.preview-ribbon');
  var textInput=document.querySelector('[data-text]');
  var width=document.querySelector('[data-width]');
  if(!primary||!primaryPosition||!ribbon)return;

  var originalGroup=primary.closest('.two');
  var primaryPositionLabel=primaryPosition.closest('label');
  var secondGroup=document.createElement('div');
  secondGroup.className='two logo-layout second-logo-layout';

  var logoLabel=document.createElement('label');
  logoLabel.append(document.createTextNode('Zweites Logo (optional)'));
  var secondary=primary.cloneNode(true);
  secondary.removeAttribute('data-symbol');
  secondary.setAttribute('data-symbol-2','');
  secondary.name='properties[Logo 2]';
  secondary.selectedIndex=0;
  logoLabel.appendChild(secondary);

  var positionLabel=document.createElement('label');
  positionLabel.append(document.createTextNode('Position des zweiten Logos'));
  var secondaryPosition=primaryPosition.cloneNode(true);
  secondaryPosition.name='properties[Logoposition Logo 2]';
  secondaryPosition.value='Hinter dem Text';
  positionLabel.appendChild(secondaryPosition);
  secondGroup.append(logoLabel,positionLabel);
  originalGroup.insertAdjacentElement('afterend',secondGroup);

  function buildPicker(select,titleText){
    select.classList.add('visual-picker-select');
    var title=document.createElement('span');
    title.className='visual-picker-title';
    title.textContent=titleText;
    var grid=document.createElement('div');
    grid.className='logo-picker';
    Array.from(select.options).forEach(function(option,index){
      var button=document.createElement('button');
      button.type='button';
      button.className='logo-choice'+(index===select.selectedIndex?' active':'')+(!option.dataset.glyph?' logo-choice-none':'');
      button.disabled=option.disabled;
      button.dataset.optionIndex=index;
      if(option.dataset.glyph){
        button.textContent=option.dataset.glyph;
        button.dataset.logoFont=option.dataset.font;
        button.style.fontFamily=option.dataset.font;
        var number=document.createElement('small');
        number.textContent=option.textContent.split(' ')[0];
        button.appendChild(number);
      }else{
        button.textContent='Kein zweites Logo';
      }
      button.title=option.textContent;
      button.addEventListener('click',function(){
        select.selectedIndex=index;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      });
      grid.appendChild(button);
    });
    select.parentElement.append(title,grid);
    return grid;
  }

  var secondGrid=buildPicker(secondary,'Zweites Logo auswählen');

  function syncPicker(select){
    var group=select.closest('.two');
    var grid=group&&group.querySelector('.logo-picker');
    if(!grid)return;
    Array.from(select.options).forEach(function(option,index){
      var button=grid.querySelector('[data-option-index="'+index+'"]');
      if(button){
        button.disabled=option.disabled;
        button.classList.toggle('active',index===select.selectedIndex);
      }
    });
  }

  function logoNode(select,slot){
    var option=select.selectedOptions[0];
    if(!option||!option.dataset.glyph)return null;
    var span=document.createElement('span');
    span.className='preview-symbol preview-symbol-'+slot;
    span.textContent=option.dataset.glyph;
    span.style.fontFamily=option.dataset.font||'inherit';
    span.style.color='inherit';
    span.style.webkitTextFillColor='currentColor';
    return span;
  }

  function textNode(repeated){
    var node=document.createElement('b');
    node.className='preview-text'+(repeated?' preview-text-repeat':'');
    node.textContent=textInput&&textInput.value?textInput.value:'Dein Wunschtext';
    return node;
  }

  function hasPosition(value,place){
    return value===place||value==='Vor und hinter dem Text'&&(place==='Vor dem Text'||place==='Hinter dem Text');
  }

  function render(){
    var hasPrimaryLogo=primary.value!=='';
    var hasSecondaryLogo=secondary.value!=='';
    primaryPosition.disabled=!hasPrimaryLogo;
    if(primaryPositionLabel)primaryPositionLabel.hidden=!hasPrimaryLogo;
    secondaryPosition.disabled=!hasSecondaryLogo;
    positionLabel.hidden=!hasSecondaryLogo;
    var selections=[
      {select:primary,position:primaryPosition.value,slot:'one'},
      {select:secondary,position:secondaryPosition.value,slot:'two'}
    ];
    var before=[],between=[],after=[];
    selections.forEach(function(item){
      if(hasPosition(item.position,'Vor dem Text')){var a=logoNode(item.select,item.slot);if(a)before.push(a)}
      if(item.position==='Zwischen den Texten'){var b=logoNode(item.select,item.slot);if(b)between.push(b)}
      if(hasPosition(item.position,'Hinter dem Text')){var c=logoNode(item.select,item.slot);if(c)after.push(c)}
    });
    var nodes=before.concat([textNode(false)]);
    if(between.length)nodes=nodes.concat(between,[textNode(true)]);
    nodes=nodes.concat(after);
    ribbon.replaceChildren.apply(ribbon,nodes);
    syncPicker(primary);
    syncPicker(secondary);
    window.dispatchEvent(new CustomEvent('band:logos-rendered'));
    requestAnimationFrame(function(){window.dispatchEvent(new Event('resize'))});
  }

  function enforceSecondary(){
    var widthValue=width&&width.selectedOptions&&width.selectedOptions[0]&&width.selectedOptions[0].dataset.width?width.selectedOptions[0].dataset.width:(width&&width.value?width.value:'10');
    var mm=location.pathname.includes('thermosatin-100-mm-bedruckt')?100:parseInt(widthValue,10);
    Array.from(secondary.options).forEach(function(option){option.disabled=Number(option.dataset.minWidth||0)>mm});
    if(secondary.selectedOptions[0]&&secondary.selectedOptions[0].disabled)secondary.value='';
    render();
  }

  primary.addEventListener('change',render);
  secondary.addEventListener('change',render);
  primaryPosition.addEventListener('change',render);
  secondaryPosition.addEventListener('change',render);
  if(textInput)textInput.addEventListener('input',render);
  if(width)width.addEventListener('change',enforceSecondary);
  window.addEventListener('band:logos-update',render);
  enforceSecondary();
});
